import { Chip } from '@mui/material'
import { memo, useMemo } from 'react'

interface QuestionCardDifficultyProps {
  difficulty: 'easy' | 'intermediary' | 'hard'
}

export const QuestionCardDifficulty = memo<QuestionCardDifficultyProps>(
  ({ difficulty }) => {
    const difficultyConfig = useMemo(
      () => ({
        easy: {
          label: 'Fácil',
          color: 'success' as const,
        },
        intermediary: {
          label: 'Médio',
          color: 'warning' as const,
        },
        hard: {
          label: 'Difícil',
          color: 'error' as const,
        },
      }),
      [],
    )

    const { label, color } = difficultyConfig[difficulty]

    return (
      <Chip
        data-qa="question-card-difficulty"
        label={label}
        color={color}
        variant="filled"
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          fontSize: '0.875rem',
          fontWeight: 700,
          height: 32,
          minWidth: 80,
        }}
      />
    )
  },
)

QuestionCardDifficulty.displayName = 'QuestionCardDifficulty'
